import React, {forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import {Button, ConfigProvider, Dropdown, Flex, Input, MenuProps, message, Modal, Tree,Tooltip} from "antd";
import Icon, {
    CaretDownOutlined,
} from '@ant-design/icons';
import type {TreeProps} from 'antd/es/tree';
import {FieldDataNode} from "rc-tree/lib/interface"
import {
    createCopyLink,
    createElementNameByNote,
    fileToBase64,
    generateRandomPageKey, generateUUID2, getDrawLeftWidth,
    getImagePathWithTheme,
    getImagePathWithThemeSvg,
    getIntValue,
    getItem,
    hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix,
    isDarkMode,
    isInSidebar,
    isStringNullOrEmpty,
    MenuItem
} from "../../utils";
import {nanoid} from "nanoid";
import TreeListNode from "@/views/Draw/TreeListNode";
import {
    DEFAULT_CANVAS_BACKGROUND,
    DEFAULT_CANVAS_BACKGROUND_DARK,
    EVENT_BOARD_CHANGED,
    EVENT_DELETE_HTML_NOTE, EVENT_FAVIRIATE_CHANGE,
    EVENT_FRAME_PREVIEW_BY_ID, EVENT_ONSCROLL_TO_ELEMENT, EVENT_REFRESH_LIBRARY_LIST, EVENT_TEST_ONDRAG_NOTE,
    EVENT_UPDATE_ELEMENT_HAS_UPDATE,
    EVENT_UPDATE_FRAME_LIST,
    EVENT_UPDATE_FRAME_SORT, HEADER_HEIGHT, KEY_DRAW_BOARD_HEIGHT, KEY_DRAW_CARD_HEIGHT, KEY_DRAW_FRAME_HEIGHT,
    KEY_DRAW_LEFT_COLLAPSE,
    KEY_LAUNCH_TIMES,
    KEY_NEW_PROJECT_ID,
    LINK_INFO_TYPE_ELEMENT,
    LINK_INFO_TYPE_FRAME,
    LINK_INFO_TYPE_NOTE,
    LINK_INFO_TYPE_PAGE, MENU_SEPARATOR, TITLE_BAR_HEIGHT,
    TREENODETYPE
} from "@/Const";
import {useTranslation} from "react-i18next";
import clipboard from "clipboardy";
import {
    IconAddBlack, IconAddToFavor, IconBackgroundColor, IconBoard, IconCopyLink,
    IconDelete, IconFavorFolderNew,
    IconFolder, IconInfoMenu,
    IconMakeCopy, IconMakeCopy_L2, IconManagerTags, IconMoveTo,
    IconPageBlack,
    IconPageCheck, IconRemoveFavor,
    IconRename,
    IconTreeFolder, IconTreeFolderCollapse, IconTreeFolderExpand
} from "@/Icon";
import DialogMessageBox from "@/common/DialogMessageBox";
import {APP_WEB, isWebApp} from "@/electron_interactive";
import TreeListFrame from "@/views/Draw/TreeListFrame";
import {postMessage, recvMessage} from "@/common/event";
import {apiElementByBoardKey} from "@/api/AppApi";
import {downloadS3ImageToBase64} from "@/api/AwsUpload";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import treeListNode from "@/views/Draw/TreeListNode";
import global from "@/global";
import {deleteBoardById, getBoardById, updateBoard} from "@model/board";
import {isMac} from "@/Utility";
import {getBoardCount} from "@model/note";
import {isZh} from "@/language";
import {ipcSend} from "@/common/ipc";
import link from "@/components/EditorV2/Link";
import {dbGetHighlight} from "@model/highlight";
import {
    findNodeLevel,
    findNodeWithParents,
    getFolderCount,
    isKeyInTree,
    loopAllNode,
    loopAllNodeWithReturn
} from "@/TreeUtils";
import {isProjectLinkElement} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {MIME_TYPES,mutateElement} from "../../../@excalidraw/packages/excalidraw";
import TreeListContent from "@/views/Draw/TreeListContent";
import {menu} from "../../../@excalidraw/packages/excalidraw/components/icons";

const {DirectoryTree} = Tree;

type DataNode = FieldDataNode<{
    key:string;
    title?:string;
    editValue?:string;
    isEditable?:boolean;
    isFolder:boolean;
    drawJson:any;
    children?:any;
    icon:any;
    isSelected?:boolean;
    isHover?:boolean;
}>


let mIsAddFolder:boolean = false;
let lastClickTime:any;
let mszMessageBoxAction:string;
let mRootDiv:any = null;//drag的folder....
let mSelectFolder:any = null;
let mIsDefaultDragOk = false;
let mIsCollapsePage = false;

let mIsCardLineDrag = false;
let mIsFrameLineDrag = false;
let mPressedY = 0;

let mBoardHeight = 0;
let mCardHeight = 0;
let mFrameHeight = 0;


const MIN_HEIGHT = 160;//最小120

// function getItem(
//     label: React.ReactNode,
//     key?: React.Key | null,
//     icon?: React.ReactNode,
//     children?: MenuItem[],
//     type?: 'group',
//     onClick?:any
// ): MenuItem {
//     return {
//         key,
//         icon,
//         children,
//         label,
//         type,
//         onClick
//     } as MenuItem;
// }


const LeftMenu = forwardRef(function _LeftMenu(props:{leftMenuItemClicked:any,
    setFirstItem:any,
    getCurrentDrawJson:any,
    onInsertNoteData:any,
    onSubNoteClick:any,
    onSelectedElement:any,
    onFramePresentClick:any,
    onChangeCanvasBackgroundClick:any,
    onNewCanvasClick:any,
    onSetUpdateElementId:any,
    onGetCanvasData:any,
    onSaveNotes:any,
    onBoardClicked:any,
    onCollapseClick:any,
    onIsLoading:any,
    onBoardTitleUpdate:any,
    onDragEnd:any,
    onAction:any,isNew:any},ref) {
    useImperativeHandle(ref, () => ({
        updateMenuData: updateMenuData,
        updateMenuData1:updateMenuData1,
        getAllMenuData: getAllMenuData,
        getAllMenuData1: getAllMenuData1,
        getAllNoteData: getAllNoteData,
        setOutMenuData: setOutMenuData,
        newProject: newProject,
        onEditNoteData: onEditNoteData,
        onPresentMode: onPresentMode,
        onGetPageDataById: onGetPageDataById,
        onGetNoteDataById: onGetNoteDataById,
        onNavMenuItemClickByLinkInfo: onNavMenuItemClickByLinkInfo,
        onNavSelectedItem: onNavSelectedItem,
        onEditNoteDataByNoteId: onEditNoteDataByNoteId,
        onGetCurrentSelectKey: onGetCurrentSelectKey,
        onSelectNoteByKey: onSelectNoteByKey,
        getSelectMenuKeys: getSelectMenuKeys,
        getCollapseStatus: getCollapseStatus,
        setOnCollapseStatus: setOnCollapseStatus,
        setOnShowOverlayStatus: setOnShowOverlayStatus,
        onMoveToPre: onMoveToPre,
        onMoveToNext: onMoveToNext,
        getBottomDesc: getBottomDesc,
        getPagesCount: getPagesCount,
        getCurrentPageFrameCount: getCurrentPageFrameCount,
        getCurrentSelectedIndex: getCurrentSelectedIndex,
        getPageSizeDesc: getPageSizeDesc,
        setOnHasPageList: setOnHasPageList,
        updateAllPageHasUpdateSign: updateAllPageHasUpdateSign,
        setFrameElementList: setFrameElementList,
        onCollapsePages: onCollapsePages,
        getAllPages: getAllPages,
        onIsFramePresent: onIsFramePresent,
        onUpdateAllCanvasBackground: onUpdateAllCanvasBackground,
        getParentNodeKey: getParentNodeKey,
        getDragNoteInfo: getDragNoteInfo,
        onAddOrUpdateDatas: onAddOrUpdateDatas,
        onGetSelectNode: onGetSelectNode,
        onRemoveSelectedItem: onRemoveSelectedItem,
        onUpdateBoard: onUpdateBoard,
        getFirstCanvasNode:getFirstCanvasNode,
        onRefreshContentElements:onRefreshContentElements
    }));

    const {t} = useTranslation();
    const treeNodeNoteRef = useRef<any>();
    const treeListContentRef = useRef<any>(null);
    const treeListFrameRef = useRef<any>();
    const dialogMessageBoxRef = useRef<any>(null);
    const mRightData = useRef<any>(null);
    //上次点击时间--限制200ms
    const mLastSelectedClickedTimes = useRef(0);
    const mIsDragging = useRef(false);
    const mDivLeftMenuContainer = useRef(null);
    const mIsInExpandClicked = useRef(false);
    const mSelectNode = useRef(null);

    //头部的高度.
    let HEADER_TOP = () => {
        if (isMac()) {
            return HEADER_HEIGHT;
        }
        return HEADER_HEIGHT + TITLE_BAR_HEIGHT;
    }

    const getMenus = (board: any,node:any) => {
        if (node.isFolder || node.children){
            return [
                getItem(t("Add board"), 'backgroundColor', <IconBoard/>, undefined, undefined, (event) => {
                    event.domEvent.stopPropagation();
                    onAddItem(node);
                }),

                getItem(t("Add folder"), 'copy', <IconFavorFolderNew/>, undefined, undefined, (event) => {
                    event.domEvent.stopPropagation();
                    onAddFolder(node);
                }),

                getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

                }),
                getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, (event) => {
                    event.domEvent.stopPropagation();
                    mRightData.current = {node:node};
                    onMenuItemContextMenu("rename",node)
                }),
                getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, (event) => {
                    event.domEvent.stopPropagation();
                    mRightData.current = {node:node};
                    //先保存项目
                    props.onSaveNotes().then(res => {
                        if (node.isFolder){
                            createCopyLink('project', PROJECT_ID, "board", mRightData.current?.node?.key,null,null,true,null,null,true);
                        }else{
                            createCopyLink('project', PROJECT_ID, "board", mRightData.current?.node?.key);
                        }

                    })
                }),
                getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, (event) => {
                    event.domEvent.stopPropagation();
                    mRightData.current = {node:node};
                    onMenuItemContextMenu("delete",node);
                    // window.showMessageBox(t("Tips"), t("DeleteTheFolder"), t("Cancel"), t("Delete"), null, () => {
                    //
                    // })
                }),
            ];
        }
        return [
            getItem(t("Rename"), 'rename', <IconRename/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                onMenuItemContextMenu("rename",node)
            }),
            getItem(board?.isFavirated == 1 ? t("Cancel favor") : t("Add to Favorites"), 'favor', board?.isFavirated == 1 ?
                <IconRemoveFavor/> : <IconAddToFavor/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                onMenuItemContextMenu("favor")
            }),
            getItem(t("Create copy"), 'copy', <IconMakeCopy_L2/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                onMenuItemContextMenu("copy")
            }),
            getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                getBoardById(node.key).then(async (res)=>{
                    if (!res){
                        //创建一个加进去..
                        res = {
                            id:node.key,
                            name:node.title,
                            projectId:PROJECT_ID,
                            sort:0,
                            type:'board',
                            isFavirated:0,
                        }
                        await updateBoard(res);
                    }
                    window.showInfo('project',res);
                })
            }),
            getItem(t("Background color"), 'backgroundColor', <IconBackgroundColor/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                props.onChangeCanvasBackgroundClick();
            }),
            getItem(t("Move to"), 'moveTo', <IconMoveTo/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                onMenuItemContextMenu("moveTo")
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("Copy link"), 'copyLink', <Icon component={() => <img className='img-14 mr-0' src={imgPathPerfix() + "menu_link_2.png"}/>}/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                //先保存项目
                props.onSaveNotes().then(res => {
                    createCopyLink('project', PROJECT_ID, "board", mRightData.current?.node?.key);
                })
            }),
            getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                getBoardById(node.key).then(res=>{
                    if (!res){
                        res = {
                            id:node.key,
                            name:node.title,
                            projectId:PROJECT_ID,
                            sort:0,
                            type:'board',
                            isFavirated:0,
                        }//跟favirate保持数据一致
                    }
                    if (!res.tags){
                        res.tags = [];
                    }
                    window.showManageTags([res]);
                })

            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),

            getItem(t("Delete"), 'delete', <IconDelete/>, undefined, undefined, (event) => {
                event.domEvent.stopPropagation();
                onMenuItemContextMenu("delete")
            }),
        ];
    }

    const defaultItem: DataNode = {
        title: t("Board"),
        key: generateRandomPageKey(),
        icon: <IconBoard/>,
        isFolder: false,
        drawJson: []
    }
    const [menuData, setMenuData] = useState<DataNode[]>(props.isNew?[defaultItem]:[])
    const [expandKeys, setExpandKeys] = useState<any>([]);
    const [treeSelectedKeys, setTreeSelectedKeys] = useState([defaultItem.key]);
    const [isMessageBoxShow, setIsMessageBoxShow] = useState(false);
    const [isTreeItemHoverPopupVisible, setIsTreeItemHoverPopupVisible] = useState(false);
    const [inputPlaceHolder, setInputPlaceHolder] = useState(t("New canvas"));
    const [inputCanvasName, setInputCanvasName] = useState('');
    const [treeDraggable, setTreeDraggable] = useState(true);
    const [isPresentMode, setIsPresentMode] = useState(APP_WEB ? true : false);
    const [isCollapsePage, setIsCollapsePage] = useState((APP_WEB || isInSidebar()) ? true : localStorage.getItem(KEY_DRAW_LEFT_COLLAPSE) == 'true');
    const [isShowOverlay, setIsShowOverlay] = useState(APP_WEB ? true : false);
    const [isShowPageTree, setIsShowPageTree] = useState(APP_WEB ? false : true);
    const [isFramePresent, setIsFramePresent] = useState(false);
    const [hasFrameElement, setHasFrameElement] = useState(false);
    const [boardHeight, setBoardHeight] = useState(getIntValue(localStorage.getItem(KEY_DRAW_BOARD_HEIGHT), (document.body.clientHeight - HEADER_TOP()) * 0.5));
    const [frameHeight, setFrameHeight] = useState(getIntValue(localStorage.getItem(KEY_DRAW_FRAME_HEIGHT), 0));
    const [cardHeight, setCardHeight] = useState(getIntValue(localStorage.getItem(KEY_DRAW_CARD_HEIGHT), (document.body.clientHeight - HEADER_TOP()) * 0.5));
    const [pointerEvent, setPointerEvent] = useState('all');
    const [arrayBoardMenus, setArrayBoardMenus] = useState([]);
    const [hoveredKey,setHoveredKey] = useState('');

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    const mMenuData = useRef<any>([]);
    const mTreeSelectedKey = useRef(null);

    function onMouseMove(event: any) {
        const nOffset = mPressedY - event.clientY;
        const nClientHeight = document.body.clientHeight;

        if (mIsCardLineDrag) {
            setPointerEvent('none');

            const nCardHeight = mCardHeight + nOffset;//(nClientHeight - event.clientY);
            mCardHeight = nCardHeight;

            if (hasFrameElement) {
                let nFrameHeight = nClientHeight - mBoardHeight - mCardHeight - HEADER_TOP() - 10;
                if (nFrameHeight > MIN_HEIGHT && mCardHeight > MIN_HEIGHT) {
                    setCardHeight(nCardHeight);

                    mFrameHeight = nFrameHeight;
                    setFrameHeight(mFrameHeight);
                }
            } else {
                let nBoardHeight = nClientHeight - nCardHeight - HEADER_TOP() - 10;
                if (nBoardHeight > MIN_HEIGHT && mCardHeight > MIN_HEIGHT) {
                    setCardHeight(nCardHeight);

                    mBoardHeight = nBoardHeight;
                    setBoardHeight(mBoardHeight);
                }
            }
        } else if (mIsFrameLineDrag) {
            setPointerEvent('none');
            const nFrameHeight = mFrameHeight + nOffset;
            mFrameHeight = nFrameHeight;

            let nBoardHeight = nClientHeight - nFrameHeight - mCardHeight - HEADER_TOP() - 10;
            if (nBoardHeight > MIN_HEIGHT && mFrameHeight > MIN_HEIGHT) {
                setFrameHeight(mFrameHeight);
                mBoardHeight = nBoardHeight;

                setBoardHeight(mBoardHeight);
                // setCardHeight(mCardHeight);
            }
        }
        mPressedY = event.clientY;
    }

    function onMouseUp(event: any) {
        mIsCardLineDrag = false;
        mIsFrameLineDrag = false;

        localStorage.setItem(KEY_DRAW_BOARD_HEIGHT, mBoardHeight + '');
        localStorage.setItem(KEY_DRAW_FRAME_HEIGHT, mFrameHeight + '');
        localStorage.setItem(KEY_DRAW_CARD_HEIGHT, mCardHeight + '');

        setPointerEvent('all');
    }

    useEffect(() => {
        document.body.addEventListener('mousemove', onMouseMove);
        document.body.addEventListener('mouseup', onMouseUp);

        window.refreshList['updateTheme_leftMenu'] = forceUpdateTheme;
        return () => {
            document.body.removeEventListener('mousemove', onMouseMove);
            document.body.removeEventListener('mouseup', onMouseUp);

            delete window.refreshList['updateTheme_leftMenu'];
        }
    })
    useEffect(() => {
        mBoardHeight = getIntValue(localStorage.getItem(KEY_DRAW_BOARD_HEIGHT), (document.body.clientHeight - HEADER_TOP()) * 0.5);
        mCardHeight = getIntValue(localStorage.getItem(KEY_DRAW_CARD_HEIGHT), (document.body.clientHeight - HEADER_TOP()) * 0.5);
        mFrameHeight = getIntValue(localStorage.getItem(KEY_DRAW_FRAME_HEIGHT), 0);

        props.setFirstItem(defaultItem);

        // setTimeout(() => {
        //     const div = document.getElementById('div-tree-left-menu');
        //     if (div) {
        //         const arrayShitTrees = div.getElementsByClassName('ant-tree-list-holder-inner');
        //         for (let i = 0; i < arrayShitTrees.length; i++) {
        //             const ddddd = arrayShitTrees[i];
        //             ddddd.classList.add('draw-ant-tree-list-holder-inner-shit-ant-tree')
        //         }
        //     }
        // }, 100)


        return () => {
            delete window.onAddNewCanvas;
        }

    }, [])

    useEffect(()=>{
        mMenuData.current = menuData;

        window.getMenuData = ()=>{
            return menuData;
        }


        window.updateBoardThumbUrl = (szBoardId:any,szThumbImage:any)=>{
            //更新项目内的缩略图..
            const arrayNewMenuData = [...menuData];
            loop(arrayNewMenuData,szBoardId,(node, i, data, parent)=>{
                node.thumbUrl = szThumbImage;
                setMenuData(arrayNewMenuData);
            })
        }

        /**
         * 更新名称
         * @param szBoardId
         * @param szNewBoardName
         */
        window.updateBoardName = async (szBoardId:any,szNewBoardName)=>{
            //更新board名称
            const arrayNewMenuData = [...menuData];
            loop(arrayNewMenuData,szBoardId,(node, i, data, parent)=>{
                node.title = node.editValue = szNewBoardName;
                setMenuData(arrayNewMenuData);
            })
            await props.onSaveNotes();
        }

        return ()=>{
            delete window.updateBoardThumbUrl;
            delete window.updateBoardName;
            delete window.getMenuData;
        }
    },[menuData])


    useEffect(() => {
        treeListFrameRef.current?.setOnIsPresentMode(isPresentMode);
    }, [isPresentMode]);

    useEffect(() => {
        if (treeSelectedKeys.length > 0) {
            mTreeSelectedKey.current = treeSelectedKeys[0];
            global.g_currentBoardId = treeSelectedKeys[0];
            //画板切换的时候，要右侧栏，因为右侧栏可能过滤的是当前项目
            postMessage(EVENT_BOARD_CHANGED);
        }
    }, [treeSelectedKeys])

    useLayoutEffect(() => {

    })

    /**
     * 主题切换-强制更新
     */
    const forceUpdateTheme = ()=>{
        forceUpdate();
        const arrayNewMenuData = [...menuData];
        loopAllNode(arrayNewMenuData,(node)=>{
            node.icon = getTreeIcon(node);
        })
        setMenuData(arrayNewMenuData);
    }

    //更新本菜单下的drawjson
    function updateMenuData(key: any, drawJson: any, menuNewData: any) {
        var menuDataNew = [];
        if (menuNewData != undefined && menuNewData != null) {
            menuDataNew.push(...menuNewData);
        } else {
            menuDataNew.push(...menuData);
        }
        recursionUpdate(menuDataNew, key, drawJson);
        setMenuData(menuDataNew);
    }

    function updateMenuData1(menuDataNew:any){
        setMenuData(menuDataNew);
    }

    //获取菜单
    function getAllMenuData() {
        var arrayNew = [...menuData];
        let currentDrawJson = props.getCurrentDrawJson();
        loop(arrayNew, treeSelectedKeys[0], (node, i, data, parent) => {
            node.drawJson = currentDrawJson;
        })
        setMenuData(arrayNew);
        return arrayNew;
    }

    function getAllMenuData1(){
        return menuData;
    }

    //获取当前选中的key
    function getSelectMenuKeys() {
        return treeSelectedKeys;
    }

    //获取笔记数据....
    function getAllNoteData() {
        return treeNodeNoteRef.current.getTreeNoteData();
    }

    /**
     * 更新所有页更新标识为没有更新了。
     */
    function updateAllPageHasUpdateSign() {
        var arrayNew = [...menuData];
        loopUpdateElementStatus(arrayNew);
        setMenuData(arrayNew);
        postMessage(EVENT_UPDATE_ELEMENT_HAS_UPDATE);

        treeNodeNoteRef.current.updateAllPageHasUpdateSign();
    }

    function loopUpdateElementStatus(arrayNew: any) {
        for (let i = 0; i < arrayNew.length; i++) {
            const item = arrayNew[i];
            if (item.isFolder) {
                arrayNew[i].hasUpdate = false;
                loopUpdateElementStatus(arrayNew[i].children);
            } else {
                arrayNew[i].hasUpdate = false;
                for (let j = 0; j < arrayNew[i].drawJson.elements.length; j++) {
                    let item = arrayNew[i].drawJson.elements[j];
                    if (item.hasUpdate) {
                        item.hasUpdate = false;
                    }
                }
            }
        }
    }

    function setFrameElementList(elements: any) {
        if (elements == undefined) {
            treeListFrameRef.current?.setFrameElementList([]);
            return;
        }
        let arrayFrameElements = elements.filter(p => p.type == 'frame');
        let hasFrameElement = false;//arrayFrameElements.length > 0;//这里换成content 不要frame了。
        setHasFrameElement(hasFrameElement);
        if (hasFrameElement) {
            //每个拿出20%
            if (mFrameHeight == 0) {//只有为0的时候才调整。第一次有frame的时候....
                mFrameHeight = mBoardHeight * 0.3 + mCardHeight * 0.3;
                setFrameHeight(mFrameHeight);
                mCardHeight = mCardHeight - mCardHeight * 0.3;
                mBoardHeight = mBoardHeight - mBoardHeight * 0.3;
                setCardHeight(mCardHeight);
                setBoardHeight(mBoardHeight);
            }
        } else {
            setFrameHeight(0);
            //均分
            mCardHeight = mCardHeight + mFrameHeight * 0.5;
            mBoardHeight = mBoardHeight + mFrameHeight * 0.5;

            setCardHeight(mCardHeight);
            setBoardHeight(mBoardHeight);
            mFrameHeight = 0;
        }
        setTimeout(() => {
            treeListFrameRef.current?.setFrameElementList(arrayFrameElements);
        }, 50);
    }

    /**
     * 设置笔记列表
     * @param elements
     */
    function setNoteFrameList(elements: any) {

    }

    //创建新的项目...
    function newProject() {
        defaultItem.key = nanoid();
        setMenuData([defaultItem]);
        setTreeSelectedKeys([defaultItem.key])
        treeNodeNoteRef.current.newProject();
        props.setFirstItem(defaultItem);
    }

    /**
     * 获取这个图标
     * @param node
     */
    const getTreeIcon = (node:any)=>{
        if (node?.isFolder){
            if (expandKeys?.includes(node.key)){
                return <IconTreeFolderExpand/>
            }
            return <IconTreeFolderCollapse/>
        }
        return <IconBoard/>
    }

    //设置外部读取的数据--
    async function setOutMenuData(menuNewData: any,linkInfo:any) {
        let nTime = Date.now();

        const arrayCanvas = menuNewData.canvas;
        const arrayNotes = menuNewData.notes;

        recursionUpdateOutMenuData(arrayCanvas);

        //显示第一条数据
        let firstNode:any = null;
        if (linkInfo && linkInfo.pageId){
            loop(arrayCanvas,linkInfo.pageId,(node, i, data, parent)=>{
                if (node.isFolder){
                    if (node.children?.length > 0){
                        firstNode = node.children[0];
                    }
                }else{
                    firstNode = node;// arrayCanvas.find(p=>p.key == linkInfo.pageId);
                }
            })
        }

        if (!firstNode){
            firstNode = getFirstCanvasNode(arrayCanvas);
        }

        firstNode.icon = getTreeIcon(firstNode);
        mSelectNode.current = firstNode;

        //处理需要展开的
        const parents:any = findNodeWithParents(arrayCanvas,firstNode.key);
        if (parents){
            const arrayExpands:any = [];
            for (let i=0;i<parents.fullPath.length;i++){
                const item = parents.fullPath[i];
                if (item != firstNode.key){
                    arrayExpands.push(item);
                }
            }
            setExpandKeys(arrayExpands);

            //需要设置的展开的文件夹图标
            loopAllNode(arrayCanvas,(item)=>{
                if (item.isFolder){
                    if (arrayExpands.includes(item.key)){
                        item.icon = <IconTreeFolderExpand/>
                    }else{
                        item.icon = <IconTreeFolderCollapse/>
                    }
                }
                item.isEditable = false;
            })
        }

        //如果之前有选中的，继续选中之前的.
        // if (treeSelectedKeys.length > 0) {
        //     for (let i = 0; i < arrayCanvas.length; i++) {
        //         if (arrayCanvas[i].key == treeSelectedKeys[0]) {
        //             arrayCanvas[0].icon = getTreeIcon(arrayCanvas[0]);
        //             arrayCanvas[i].isChecked = true;
        //             firstNode = arrayCanvas[i];
        //             firstNode.icon = getTreeIcon(firstNode);
        //         }
        //     }
        // }


        setMenuData(arrayCanvas);
        setTreeSelectedKeys([firstNode.key]);
        props.setFirstItem(null);

        // console.log('leftMenu-setOutMenuData-leftMenuItemClicked-up:',(Date.now() - nTime))
        await props.leftMenuItemClicked(firstNode);
        // console.log('leftMenu-setOutMenuData-leftMenuItemClicked-down:',(Date.now() - nTime))

        treeNodeNoteRef.current?.setTreeNoteData(arrayNotes,arrayCanvas);
        treeListContentRef.current?.onRefreshElement(firstNode.drawJson.elements);

        setFrameElementList(firstNode.drawJson.elements);

        /* 原note 依赖画布的
        recursionUpdateOutMenuData(menuNewData);
        setMenuData(menuNewData);
        //显示第一条数据
        const firstNode = getFirstCanvasNode(menuNewData);
        setTreeSelectedKeys([firstNode.key]);
        props.setFirstItem(null);
        props.leftMenuItemClicked(firstNode);
        treeNodeNoteRef.current.setTreeNoteData(firstNode.subNotes);
         */
        // console.log('leftMenu-setOutMenuData:',(Date.now() - nTime))
    }

    /**
     * 设置需要展开的...
     * @param arrayCanvas
     * @param szKey
     */
    function onSetExpandKey(arrayCanvas,szKey){
        const parents:any = findNodeWithParents(arrayCanvas,szKey);
        if (parents){
            const arrayExpands:any = [];
            for (let i=0;i<parents.fullPath.length;i++){
                const item = parents.fullPath[i];
                if (item != szKey){
                    arrayExpands.push(item);
                }
            }
            setExpandKeys(arrayExpands);

            //需要设置的展开的文件夹图标
            loopAllNode(arrayCanvas,(item)=>{
                if (item.isFolder){
                    if (arrayExpands.includes(item.key)){
                        item.icon = <IconTreeFolderExpand/>
                    }else{
                        item.icon = <IconTreeFolderCollapse/>
                    }
                }
            })
        }
    }

    /**
     * 设置展示模式
     */
    function onPresentMode(isPresentMode: boolean) {
        setIsPresentMode(isPresentMode);
        // setIsCollapsePage(false);
        if (isPresentMode) {
            const nPagesCount = getPagesCount();
            // if (nPagesCount == 1){
            //     setIsCollapsePage(true);
            // }
            setIsCollapsePage(true);
        }
        //更新所有的icon,展示模式使用暗色的主题
        // const arrayMenuDataaaaaaaaaaaaaas = [...menuData];
        // loopAllNode(arrayMenuDataaaaaaaaaaaaaas,(node)=>{
        //     if (node.isFolder)
        // })
    }

    const onIsFramePresent = (isFramePresent: boolean) => {
        setIsFramePresent(isFramePresent);
        treeListFrameRef.current?.onIsFramePresent(isFramePresent);
    }

    const onUpdateAllCanvasBackground = (szHexColor: string, isAllPage: boolean) => {
        let arrayNew = [...menuData];
        for (let i = 0; i < arrayNew.length; i++) {
            const item = arrayNew[i];
            if (item.isFolder) {
                for (let j = 0; j < item.children.length; j++) {
                    const subItem = item.children[j];
                    if (!isAllPage && subItem.key != treeSelectedKeys[0]) {
                        continue;
                    }
                    subItem.drawJson.appState.viewBackgroundColor = szHexColor;
                }
            } else {
                if (!isAllPage && item.key != treeSelectedKeys[0]) {
                    continue;
                }
                if ('appState' in item.drawJson) {
                    item.drawJson.appState.viewBackgroundColor = szHexColor;
                }
            }
        }
        setMenuData(arrayNew);
    }

    /**
     * 获取父节点key
     * @param szKey
     */
    const getParentNodeKey = (szKey: string) => {
        for (let i = 0; i < menuData.length; i++) {
            const item = menuData[i];
            if (item.isFolder) {
                for (let j = 0; j < item.children.length; j++) {
                    const subItem = item.children[j];
                    if (subItem.key == szKey) {
                        return item.key;
                    }
                }
            }
        }
        return '';
    }

    /**
     * 当前在拖动的。。。。
     */
    const getDragNoteInfo = () => {
        return treeNodeNoteRef.current?.getDragNoteInfo?.();
    }

    const onAddOrUpdateDatas = (id: string, szTitle: string, noteDataDoc: string) => {
        treeNodeNoteRef.current.onAddOrUpdateDatas(id, szTitle, noteDataDoc);
    }

    /**
     * 当前选中的节点
     */
    const onGetSelectNode = () => {
        if (menuData.length == 1 || !mSelectNode.current) return menuData[0];
        return mSelectNode.current;
    }

    /**
     * 获取展开折叠状态
     */
    function getCollapseStatus() {
        return isCollapsePage;
    }

    /**
     * 设置折叠状态
     * @param isCollapse
     */
    function setOnCollapseStatus(isCollapse) {
        mIsCollapsePage = isCollapse;
        setIsCollapsePage(isCollapse);
    }

    function setOnShowOverlayStatus(isShowOverlay) {
        setIsShowOverlay(isShowOverlay)
    }

    /*j*/
    function setOnHasPageList(hasPageList) {
        setIsShowPageTree(hasPageList);
    }

    /**
     * 根据ID获取TREE 数据
     * @param id
     */
    function onGetPageDataById(id) {
        let q;
        loop(menuData, id, ((node, i, data, parent) => {
            q = node;
        }));
        return q;
    }

    function onGetNoteDataById(id, generationDataId) {
        return treeNodeNoteRef?.current.onGetPageDataById(id, generationDataId);
    }


    /**
     * 根据ID转到画布
     * @param id
     */
    function onNavMenuItemClickByLinkInfo(linkInfo) {
        if (linkInfo.type == LINK_INFO_TYPE_PAGE) {
            let pageId = linkInfo.id;
            if (linkInfo.pageId) {
                pageId = linkInfo.pageId;
            }
            //page
            loop(menuData, pageId, ((node, i, data, parent) => {
                mSelectNode.current = node;

                const parents = findNodeWithParents(menuData,pageId);
                const arrayExpandsKeys = [];
                if (parents?.parents){
                    for (let pp=0;pp<parents.parents.length;pp++){
                        arrayExpandsKeys.push(parents.parents[pp].key);
                    }
                    setExpandKeys(arrayExpandsKeys);
                }
                // if (parent != null && parent != undefined) {
                //     setExpandKeys([parent?.key])
                // }
                setTreeSelectedKeys([pageId]);
                canvaItemSelect(menuData);
            }))

        } else if (linkInfo.type == LINK_INFO_TYPE_NOTE) {
            //note
            treeNodeNoteRef?.current.onEditNoteDataByNoteId(linkInfo.id, isPresentMode);

        } else if (linkInfo.type == LINK_INFO_TYPE_FRAME) {
            //是否需要切换page--切换page会闪动...
            if (treeSelectedKeys.length > 0 && treeSelectedKeys[0] == linkInfo.pageId) {
                //切换到相应的frame
                setTimeout(() => {
                    postMessage(EVENT_FRAME_PREVIEW_BY_ID, {id: linkInfo.id})
                }, 110);
            } else {
                //切换到pageid->id
                loop(menuData, linkInfo.pageId, ((node, i, data, parent) => {
                    mSelectNode.current = node;
                    if (parent != null && parent != undefined) {
                        setExpandKeys([parent?.key])
                    }
                    setTreeSelectedKeys([linkInfo.pageId]);
                    canvaItemSelect(menuData);

                    //切换到相应的frame
                    setTimeout(() => {
                        // postMessage(EVENT_FRAME_PREVIEW_BY_ID,{id:linkInfo.id})
                    }, 110);
                }))
            }
        } else if (linkInfo.type == LINK_INFO_TYPE_ELEMENT) {
            //到某一个元素
            if (linkInfo.isCurrentProject) {
                if (linkInfo.pageId == onGetCurrentSelectKey()) {
                    postMessage(EVENT_ONSCROLL_TO_ELEMENT, {elementId: linkInfo.elementId})
                } else {
                    //转到page 选中元素
                    onNavSelectedItem(linkInfo.pageId).then(res => {
                        postMessage(EVENT_ONSCROLL_TO_ELEMENT, {elementId: linkInfo.elementId})
                    })
                }
            }

        }
    }

    function getBottomDesc(szPageId) {
        let arrayAllPages = [];
        let nCurIndex = 0;
        loopAllNode(menuData,(item)=>{
            if (item.drawJson){
                arrayAllPages.push(item);
            }
        })
        // for (let i = 0; i < menuData.length; i++) {
        //     var item = menuData[i];
        //     if (item.isFolder) {
        //         arrayAllPages.push(...item.children);
        //     } else {
        //         arrayAllPages.push(item);
        //     }
        // }
        for (let i = 0; i < arrayAllPages.length; i++) {
            if (arrayAllPages[i].key === szPageId) {
                nCurIndex = i;
                break;
            }
        }
        return (nCurIndex + 1) + '/' + arrayAllPages.length;
    }

    /**
     * 选中某一个条目
     * @param szKey
     */
    function onNavSelectedItem(szKey: string) {
        return new Promise(resolve => {
            loop(menuData, szKey, async (node, i, data, parent) => {
                setTreeSelectedKeys([szKey]);
                //展开相应的...
                onSetExpandKey(menuData,szKey);

                mSelectNode.current = node;
                await canvaItemSelect(menuData);
                resolve('');
            })
        })
    }

    /**
     * 选中上一个
     */
    function onMoveToPre() {
        //当前的 --all
        let arrayAllPages = [];
        loopAllNode(menuData,(item)=>{
            if (item.drawJson){
                arrayAllPages.push(item);
            }
        })
        // for (let i = 0; i < menuData.length; i++) {
        //     var item = menuData[i];
        //     if (item.isFolder) {
        //         arrayAllPages.push(...item.children);
        //     } else {
        //         arrayAllPages.push(item);
        //     }
        // }
        //当前索引
        let nCurIndex = 0;
        if (treeSelectedKeys.length > 0) {
            for (let i = 0; i < arrayAllPages.length; i++) {
                if (arrayAllPages[i].key === treeSelectedKeys[0]) {
                    nCurIndex = i;
                    break;
                }
            }
        }
        nCurIndex--;
        if (nCurIndex < 0) {
            nCurIndex = arrayAllPages.length - 1;
        }
        onNavSelectedItem(arrayAllPages[nCurIndex].key);

        return (nCurIndex + 1) + ' / ' + arrayAllPages.length;
    }

    /**
     * 选中下一个
     */
    function onMoveToNext() {
        //当前的 --all
        let arrayAllPages = [];
        loopAllNode(menuData,(item)=>{
            if (item.drawJson){
                arrayAllPages.push(item);
            }
        })

        // for (let i = 0; i < menuData.length; i++) {
        //     var item = menuData[i];
        //     if (item.isFolder) {
        //         arrayAllPages.push(...item.children);
        //     } else {
        //         arrayAllPages.push(item);
        //     }
        // }
        //当前索引
        let nCurIndex = 0;
        if (treeSelectedKeys.length > 0) {
            for (let i = 0; i < arrayAllPages.length; i++) {
                if (arrayAllPages[i].key === treeSelectedKeys[0]) {
                    nCurIndex = i;
                    break;
                }
            }
        }
        nCurIndex++;
        if (nCurIndex >= arrayAllPages.length) {
            nCurIndex = 0;
        }
        onNavSelectedItem(arrayAllPages[nCurIndex].key);

        return (nCurIndex + 1) + ' / ' + arrayAllPages.length;
    }


    //第一个画布...
    function getFirstCanvasNode(arrayMenuDatas: any) {
        let firstNode = null;
        const arrayCanvas = arrayMenuDatas || menuData;
        loopAllNode(arrayCanvas,(node)=>{
            if (!firstNode && node.drawJson?.elements){
                firstNode = node;
            }
        })
        return firstNode;
    }

    /**
     * 刷新content的列表
     * @param arrayElements
     */
    function onRefreshContentElements(arrayElements){
        treeListContentRef.current?.onRefreshElement(arrayElements);
    }

    /**
     * 获取可用页的数量
     */
    function getPagesCount() {
        let nCount = 0;
        loopAllNode(menuData,(item)=>{
            if (item.isFolder || item.children) {
                // nCount += item.children.length;
            } else {
                nCount++;
            }
        })
        return nCount;
    }

    //当前frame的数量
    function getCurrentPageFrameCount() {
        if (treeSelectedKeys.length > 0) {
            for (let i = 0; i < menuData.length; i++) {
                if (menuData[i].key == treeSelectedKeys[0]) {
                    return menuData[i].drawJson?.elements?.filter(p => p.type == 'frame').length;
                }
            }
        }

        return 1;
    }

    /**
     * 当前选择的page
     */
    function getCurrentSelectedIndex() {
        let arrayAllPages = getAllPages();
        let nCurIndex = 0;
        for (let i = 0; i < arrayAllPages.length; i++) {
            if (treeSelectedKeys[0] == arrayAllPages[i].key) {
                nCurIndex = i;
                break;
            }
        }
        return nCurIndex;
    }

    function getPageSizeDesc() {
        if (isFramePresent) {
            return (1) + " / " + getCurrentPageFrameCount();
        }
        return (getCurrentSelectedIndex() + 1) + " / " + getPagesCount();
    }

    function getFrameSizeDesc() {

    }

    /**
     * 编辑笔记数据
     * @param element
     */
    function onEditNoteData(element, isReadOnlyMode: boolean = false) {
        treeNodeNoteRef.current.onEditNoteData(element, isReadOnlyMode);
    }

    function onEditNoteDataByNoteId(szNoteId) {
        setTimeout(() => {
            treeNodeNoteRef.current.onEditNoteDataByNoteId(szNoteId);
        }, 100);
    }

    /**
     * 当前选中的KEY
     */
    function onGetCurrentSelectKey() {
        if (treeSelectedKeys.length > 0)
            return treeSelectedKeys[0];
        return menuData[0].key;
    }

    /**
     * 选中笔记
     * @param szKey
     */
    function onSelectNoteByKey(szKey, szParentKey) {
        treeNodeNoteRef.current.onSelectNoteByKey(szKey, szParentKey);
    }


    //递归更新....
    function recursionUpdateOutMenuData(menuData: any) {
        for (var i = 0; i < menuData.length; i++) {
            var item = menuData[i];
            if (item.isFolder) {
                item.icon = <IconTreeFolderCollapse/>;
                recursionUpdateOutMenuData(item.children);
            } else {
                item.icon = <IconBoard rev={undefined}/>;
                // item.drawJson = JSON.parse(item.drawJson);
            }
        }
    }

    //找当前的KEY所有的条目，并更新...
    function recursionUpdate(menuDataNew: any, key: any, drawJson: any) {
        for (var i = 0; i < menuDataNew.length; i++) {
            var item = menuDataNew[i];
            if (item.isFolder) {
                recursionUpdate(item.children, key, drawJson);
            } else {
                if (item.key == key) {
                    item.drawJson = drawJson;
                    //更新subnote---这里不要。。。。
                    // item.subNotes = treeNodeNoteRef.current.getTreeNoteData();
                }
            }
        }
    }


    const canvaItemSelect = async (menuNewData: any) => {
        if (mSelectNode.current.isFolder) {

        } else {
            // menuNewData.forEach(p => {
            //     if (p.key == mSelectNode.key) {
            //         p.icon = getTreeIcon(p)
            //     } else {
            //         p.icon = getTreeIcon(p);
            //     }
            // })

            //刷新content
            treeListContentRef.current?.onRefreshElement(mSelectNode.current.drawJson.elements);

            await props.leftMenuItemClicked(mSelectNode.current, menuNewData);
            //原笔记随画布切换....
            // treeNodeNoteRef.current.setTreeNoteData(mSelectNode.subNotes);
            setFrameElementList(mSelectNode.current.drawJson.elements);

            props.onBoardClicked(mSelectNode.current,false,menuNewData);


        }
    }

    /**
     * 这玩意不能写到 util里面》》》》》》
     * @param arrayElements
     */
    const s3ImageToLocalFile = async (arrayElements: any) => {
        const arrayImageElements = arrayElements.filter(p => p.type == 'image' && !p.extra?.svg);
        let arrayFiles = await downloadS3ImageToBase64(arrayImageElements);

        const arraySvgElements = arrayElements.filter(p => p.type == 'image' && p.extra?.svg);
        for (let i = 0; i < arraySvgElements.length; i++) {
            const element = arraySvgElements[i];
            const imageFile = new Blob([element.extra.svgText], {type: MIME_TYPES.svg});
            const szBase64 = await fileToBase64(imageFile);
            arrayFiles[element.fileId] = {
                mimeType: 'image/svg+xml',
                id: element.fileId,
                dataURL: szBase64,
                created: Date.now(),
                lastRetrieved: Date.now()
            }
        }

        return arrayFiles;
    }


    /**
     * tree选择.....
     */
    const onSelect: TreeProps["onSelect"] = (async (selectedKeys: any, info) => {
        if (mTreeSelectedKey.current !== selectedKeys[0] && (Date.now() - mLastSelectedClickedTimes.current) < 300){
            console.log('*****onSelect----ret*******',selectedKeys);
            return;
        }

        if (!global.g_isLoadingFinished){
            console.log('*****isLoading*******',selectedKeys);
            return;
        }

        mLastSelectedClickedTimes.current = Date.now();

        if (info.node.isFolder){
            return;
            // if (!mIsInExpandClicked.current){
            //     console.log('onselect');
            //     //这里是点击没有进入onExpand??????
            //     //判断一下这个selectedKey
            //     if (selectedKeys.length > 0){
            //         const arrayExpands = [...expandKeys];
            //         const nIndex = arrayExpands.findIndex(p=>p == selectedKeys[0]);
            //         if (nIndex != -1){
            //             //删除这个
            //             arrayExpands.splice(nIndex,1);
            //         }else{
            //             arrayExpands.push(selectedKeys[0]);
            //         }
            //         mExpandKeys.current = arrayExpands;
            //         setExpandKeys(arrayExpands);
            //     }
            // }
            // mIsInExpandClicked.current = false;
            // return;
        };


        if (isFramePresent) {
            for (let i = 0; i < menuData.length; i++) {
                const item = menuData[i];
                if (item.key == selectedKeys[0]) {
                    if (item.drawJson.elements.filter(p => p.type == 'frame').length == 0) {
                        message.info(t('No frame on this board'));
                        return;
                    }
                }
            }

            setTimeout(() => {
                props.onFramePresentClick("preview");
            }, 200);
        }
        var now = new Date().getTime();
        if (now - lastClickTime < 200 && treeSelectedKeys.length > 0 && treeSelectedKeys[0] == selectedKeys[0]) {
            //双击
            if (isPresentMode) return;

            const data = [...menuData];
            loop(data, selectedKeys[0], (item) => {
                item.isEditable = true;
                item.editValue = item.title;

                setTimeout(()=>{
                    const txt = document.getElementById('txt-directory-item-'+item.key);
                    if (txt){
                        txt.focus();
                    }
                },100)
            });
            setMenuData(data)
            setTreeDraggable(false);
            if (treeSelectedKeys.length > 0 && treeSelectedKeys[0] != selectedKeys[0]) {
                setTreeSelectedKeys(selectedKeys);
                mSelectNode.current = info.node
                //重置所有未选择
                mSelectNode.current.isSelected = true;
                props.onBoardClicked(mSelectNode.current,true,menuData);
                await canvaItemSelect(menuData);

                //这里更新
                if (window.onUpdateNoteFilter){
                    window.onUpdateNoteFilter();
                }
            }
        } else {
            if (treeSelectedKeys != null && treeSelectedKeys.length > 0 && treeSelectedKeys[0] == selectedKeys[0]) {
                lastClickTime = new Date().getTime();
                return;
            }
            if (isWebApp()) {
                //region webapp
                const data = [...menuData];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].key == selectedKeys[0]) {
                        if (data[i].drawJson.elements.length > 0 || data[i].isQueryed) {
                            //转到这个页面......
                            setTreeSelectedKeys(selectedKeys);
                            mSelectNode.current = info.node
                            //重置所有未选择
                            mSelectNode.current.isSelected = true;

                            canvaItemSelect(menuData);
                        } else {
                            // window?.showSmallLoading();
                            apiElementByBoardKey(data[i].key).then(async (res) => {
                                if (res.code == 0) {
                                    data[i].isQueryed = true;
                                    //添加到已处理的map...
                                    res.data.forEach(p => {
                                        props.onSetUpdateElementId(p.id);
                                    })
                                    data[i].drawJson.elements = res.data;
                                    //处理这一页的图片....
                                    data[i].drawJson.files = await s3ImageToLocalFile(data[i].drawJson.elements);

                                    //转到这个页面......
                                    setTreeSelectedKeys(selectedKeys);
                                    mSelectNode.current = info.node
                                    //重置所有未选择
                                    mSelectNode.current.isSelected = true;

                                    canvaItemSelect(menuData);
                                    // window?.closeSmallLoading();
                                }
                            });
                        }

                        break;
                    }
                }
                //endregion
            } else {
                setTreeSelectedKeys(selectedKeys);
                mSelectNode.current = info.node
                //重置所有未选择
                mSelectNode.current.isSelected = true;
                props.onBoardClicked(mSelectNode.current,true,menuData);
                await canvaItemSelect(menuData);

                //这里更新
                if (window.onUpdateNoteFilter){
                    window.onUpdateNoteFilter();
                }
            }
        }

        lastClickTime = new Date().getTime();
    })


    const onExpand: TreeProps["onExpand"] = ((expandedKeys: any, expanded) => {
        mIsInExpandClicked.current = true;
        if (!expanded.node.isFolder)return;
        if (mIsDragging.current)return;

        if (expanded.node.isEditable)return;

        //修改文件夹样式
        const arrayNewData = [...menuData];
        loopAllNode(arrayNewData,(item)=>{
            if (item.isFolder){
                if (expandedKeys.includes(item.key)){
                    item.icon = <IconTreeFolderExpand/>
                }else{
                    item.icon = <IconTreeFolderCollapse/>
                }
            }
        })

        setExpandKeys(expandedKeys);
    })

    const onDragStart = (info)=>{
        console.log('onDragStart');
        mIsDragging.current = true;
    }

    const isMouseInDiv = (event)=>{
        const x = event.clientX;
        const y = event.clientY;
        const rects = event.currentTarget.getClientRects();
        const rect = rects[0];


        // console.log('onDragOver:',`x:${x} y:${y}`,rect);
        return (x > rect.left && x<(rect.right - 11)  && y > rect.top && y<(rect.bottom - 11))
    }

    const onDragOver = (info) => {
        // console.log(info.node);
        mIsDefaultDragOk = false;

        if (mRootDiv != null) {
            mRootDiv.style.border = '0px';
        }
        mSelectFolder = null;


        if (info.node.isFolder) {
            //判断当前经过的点是否在这个区域内.
            // const x = info.event.clientX;
            // const y = info.event.clientY;
            // const rects = info.event.currentTarget.getClientRects();
            // const rect = rects[0];
            mRootDiv = info.event.currentTarget;

            // console.log('onDragOver:',`x:${x} y:${y}`,rect);
            if (isMouseInDiv(info.event)){
                mRootDiv.style.border = '1px solid #0085FF';
            }else{
                mRootDiv.style.border = '0px solid #0085FF';
            }
            mSelectFolder = mRootDiv;
        } else {
            //根据ID找到父级
            loop(menuData, info.node.key, ((node, i, data, parent) => {
                if (parent != undefined) {
                    var div = document.getElementById(parent.key);
                    if (div != undefined) {
                        mRootDiv = div.parentElement.parentElement.parentElement;
                        // mRootDiv.style.border = '1px solid #0085FF';
                    }
                }
            }))
        }
    }

    const onDragEnd = (info) => {
        mIsDragging.current = false;

        //// 这里执行到画布上的操作.
        if (global.g_isPresentMode) return;

        // mDivLeftMenuContainer.current.getBoundingClientRect().left +
        let mOffset = mDivLeftMenuContainer.current?.offsetWidth * 2;
        if (info.event.clientX > mOffset){
            if (info.node.isFolder){
                message.error(t("ThisOperationIsNotSupported"))
            }else{
                const dragData = {
                    ...info.node,
                    x: info.event.clientX,
                    y: info.event.clientY,
                    type:'board'
                }

                postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
            }
        }else{
            if (mRootDiv != null) {
                mRootDiv.style.border = '0px';
            }

            if (mSelectFolder != null && !mIsDefaultDragOk) {
                let szMoveKey = info.node.key;
                if (info.dragNode != undefined) {
                    szMoveKey = info.dragNode.key;
                }

                var arrayDivs = mSelectFolder.getElementsByClassName("custom-element");
                if (arrayDivs.length > 0) {
                    setTimeout(() => {
                        var szDestKey = arrayDivs[0].id;
                        var arrayNew = [...menuData];

                        const nLevel = findNodeLevel(arrayNew,szDestKey);
                        if (nLevel >= 1)return;

                        loop(arrayNew,szDestKey,(item, i, data, parent)=>{
                            if (item.isFolder){
                                var newNode = loopRemove(arrayNew, szMoveKey);
                                if (newNode) {
                                    item.children.splice(0, 0, newNode);
                                    setMenuData(arrayNew);
                                    onExpandAndNavIfBoard(arrayNew,newNode);

                                    if (props.onDragEnd){
                                        props.onDragEnd().then(res=>{
                                            window.globalRefreshList('embedProject_');
                                        });
                                    }
                                }
                            }
                        })
                    }, 50);
                }
            }
        }

    }

    const onDrop: TreeProps['onDrop'] = (info) => {
        console.log(info);
        if (mRootDiv != null) {
            mRootDiv.style.border = '0px';
        }
        var isDragOk = true;
        const dropKey = info.node.key;
        const dragKey = info.dragNode.key;
        const dropPos = info.node.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        //移到的节点的level---不要深度判断
        // const nDestLevel = findNodeLevel(menuData,dropKey)
        // if (info.dragNode.isFolder &&  (nDestLevel > 1 || (info.node.isFolder && nDestLevel > 0))){
        //     message.error(t('MaximumFolder'));
        //     isDragOk = false;
        //     return;
        // }

        //如果当前节点是文件夹并且下面带的还有文件夹，不能移动到别的文件夹下。
        let isDragNodeChildHasFolder = false;
        // if (info.dragNode.isFolder){
        //     for (let i=0;i<info.dragNode.children.length;i++){
        //         const childItem = info.dragNode.children[i];
        //         if (childItem.isFolder){
        //             isDragNodeChildHasFolder = true;
        //             break;
        //         }
        //     }
        // }

        const data = [...menuData];

        // Find dragObject
        let dragObj: DataNode;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        mIsDefaultDragOk = false;

        if (!info.dropToGap) {
            /// Drop on the content
            let nFolderPosition = -1;
            loop(data, dropKey, (item, i: number, data: DataNode[], parent?: DataNode) => {

                if (!item.children) {//不能移到画布下一级。。。。
                    //插入到当前下...
                    // for (let i=0;i<data.length;i++){
                    //     const favor = data[i];
                    //     if (favor.isFolder){
                    //         const nCurIndex = favor.children.findIndex(p=>p.id == item.id);
                    //         if (nCurIndex != -1){
                    //             //插入到这个位置
                    //             favor.children.splice(nCurIndex+1, 0, info.dragNode);
                    //             isDragOk = true;
                    //             break;
                    //         }
                    //     }
                    // }
                    if (parent){
                        const nCurIndex = parent?.children.findIndex(p=>p.key == item.key);
                        if (nCurIndex != undefined && nCurIndex != -1){
                            if (parent?.children){
                                parent.children.splice(nCurIndex+1,0,info.dragNode);
                                isDragOk = true;
                            }
                        }
                    }else {
                        //在根目录的画布自行交换.
                        const nCurIndex = data.findIndex(p => p.key == item.key);
                        if (nCurIndex != undefined && nCurIndex != -1) {
                            data.splice(nCurIndex + 1, 0, info.dragNode);
                            isDragOk = true;
                        }
                    }

                } else {
                    //不能拖动到别的文件夹下。。只能在一级..
                    if (isDragNodeChildHasFolder){
                        message.error(t('MaximumFolder'));
                        isDragOk = false;
                    }else{
                        if (info.dragNode.isFolder && item.isFolder) {
                            isDragOk = true;
                            //添加到和item下面的下面一个位置.
                            // nFolderPosition = data.findIndex(p=>p.key == item.key);
                            item.children.unshift(dragObj);
                        } else {
                            item.children = item.children || [];
                            // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                            item.children.unshift(dragObj);
                        }
                    }
                }
            });
            // if (nFolderPosition != -1){
            //     //添加到和item平级的下面一个位置.
            //     data.splice(nFolderPosition+1,0,info.dragNode);
            // }
            if (isDragOk){
                mIsDefaultDragOk = true;
            }
        } else if (
            ((info.node as any).props.children || []).length > 0 && // Has children
            (info.node as any).props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item) => {
                if (item.children == null) {//不能移到画布下。。。。
                    isDragOk = false;
                } else {
                    if (info.dragNode.isFolder && item.isFolder) {
                        isDragOk = false;
                    } else {
                        item.children = item.children || [];
                        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
                        item.children.unshift(dragObj);
                        // in previous version, we use item.children.push(dragObj) to insert the
                        // item to the tail of the children
                    }
                }
            });
        } else {
            let ar: DataNode[] = [];
            let i: number;
            loop(data, dropKey, (_item, index, arr, parent) => {
                if ((info.dragNode.isFolder && (_item.isFolder || parent?.isFolder))) {
                    isDragOk = true;
                    //移动位置....
                    ar = arr;
                    i = index;
                    // if (isMouseInDiv(info.event)){
                    //     if (_item.isFolder){
                    //         ar = _item.children;
                    //     }
                    // }

                } else {
                    ar = arr;
                    i = index;
                    // if (isMouseInDiv(info.event)){
                    //     if (_item.isFolder){
                    //         ar = _item.children;
                    //     }
                    // }
                }
            });
            if (dropPosition === -1) {
                ar.splice(i!, 0, dragObj!);
            } else {
                ar.splice(i! + 1, 0, dragObj!);
            }
        }

        if (isDragOk) {
            // for (let i = 0; i < data.length; i++) {
            //     data[i].sort = i;
            // }
            setMenuData(data);
        }

        if (menuData.length != data.length) {
            mIsDefaultDragOk = true;
        }
        // onDragEnd(info,isDragOk,menuData);
        mIsDragging.current = false;

        //展开父文件夹并转到这个画布，如果是画布的话.
        onExpandAndNavIfBoard(data,info.dragNode);

        if (props.onDragEnd){
            props.onDragEnd().then(res=>{
                window.globalRefreshList('embedProject_');
            });
        }
    };

    const onTreeMouseEnter: TreeProps["onMouseEnter"] = (event) => {
        // console.log(event);
        if (isPresentMode) return;

        setHoveredKey(event.node.key);
        // var newData = [...mMenuData.current];
        // resetHoverStatus(newData, event.node.key);
        // setMenuData(newData);
    }

    const onTreeMouseLeave: TreeProps["onMouseLeave"] = (event) => {

        // var newData = [...mMenuData.current];
        // resetHoverStatus(newData, "");
        // setMenuData(newData);
        // setIsTreeItemHoverPopupVisible(false)
        setHoveredKey('')
    }

    /**
     * 展开父文件夹并转到这个画布，如果是画布的话.
     * @param dragNode
     */
    const onExpandAndNavIfBoard = (data,dragNode:any)=>{
        //展开并选中这个拖动的画布..
        const parents = findNodeWithParents(data,dragNode.key);
        const arrayExpands = [...expandKeys];
        if (parents?.parents){
            for (let i=0;i<parents.parents.length;i++){
                if (!arrayExpands.includes(parents.parents[i].key)){
                    arrayExpands.push(parents.parents[i].key);
                }
            }
            setExpandKeys(arrayExpands);
        }

        if (!dragNode.isFolder){
            //转到这个..
            setTreeSelectedKeys([dragNode.key]);
            mSelectNode.current = dragNode;
            //重置所有未选择
            mSelectNode.current.isSelected = true;
            props.onBoardClicked(mSelectNode.current,true,data);
            canvaItemSelect(data);
        }
    }

    const onAdd = (key: any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            const children = Array.isArray(item.children) ? [...item.children] : []
            children.push({
                key: nanoid(), // 这个 key 应该是唯一的
                title: "default",
                // level: item.level + 1
            })
            item.children = children
        });
        // @ts-ignore
        setExpandKeys([...expandKeys, key])
        setMenuData(data);
    };

    const onEdit = (key: any) => {
        const data = [...menuData];
        closeNode(data);
        loop(data, key, (item) => {
            item.editValue = item.title
            item.isEditable = true
        });
        setMenuData(data);

    };

    // input 改变
    const onChange = (e: any, key: any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
            if (!item.isFolder){
                //更新到收藏夹
                getBoardById(item.key).then(res => {
                    if (res) {
                        res.name = item.title;
                        updateBoard(res);
                        postMessage(EVENT_FAVIRIATE_CHANGE)
                    }
                })
                props.onBoardTitleUpdate(item);
            }else{
                props.onBoardTitleUpdate(item);
            }
        });
        setMenuData(data)
    };

    //丢失焦点
    const onBlur = (e: any, key: any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.editValue = e.target.value;
            item.title = item.editValue;
            item.isEditable = false;
        });
        setMenuData(data)

        setTreeDraggable(true);

        //保存.
        props.onSaveNotes().then(r=>{
            //刷新画布上引用的project
            window.globalRefreshList('embedProject_');
            //刷新content
            const currentDrawJson = noteGetCurrentDrawJson();
            if (window.onRefreshElement && currentDrawJson?.elements){
                window.onRefreshElement(currentDrawJson.elements);
            }
            if (isInSidebar()){
                //这里还要刷新外面的project的title??----------
                // window.parent.postMessage({action:szAction,data:data})
                props.onAction('sendMessage-refreshContent');
            }else{
                props.onAction('draw2Slider-sendMessage-refreshContent');
            }
        });
    }

    const onCanvasKeyPress = (e, key) => {
        if (e.charCode == 13) {
            e.currentTarget.blur();
        }
    }

    // 保存
    const onSave = (key: any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.isEditable = false
            item.title = item.editValue || ''
        });
        console.log(data)
        setMenuData(data);
    };

    // 关闭输入
    const onClose = (key: any) => {
        const data = [...menuData];
        loop(data, key, (item) => {
            item.editValue = item.title
            item.isEditable = false
        });
        setMenuData(data);
    };

    const closeNode = (data: any) =>
        data.forEach((item: any) => {
            item.isEditable = false;
            if (item.children) {
                closeNode(item.children);
            }
        });

    const onDelete = (key: any) => {
        const data = [...menuData];
        loop(data, key, (_, index, arr) => {
            arr.splice(index, 1);
        });
        setMenuData(data);
    };

    // 找到节点数据并回调处理节点方法 callback回调: node-当前节点 i-当前节点序号 data-包含当前节点的节点组 parentNode 当前节点父节点
    const loop = (
        data: DataNode[],
        key: React.Key,
        callback: (node: DataNode, i: number, data: DataNode[], parent?: DataNode) => void,
        parentNode?: DataNode,
    ) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                return callback(data[i], i, data, parentNode);
            }
            if (data[i].children) {
                loop(data[i].children!, key, callback, data[i]);
            }
        }
    };

    const loopRemove = (data, key) => {
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            if (item.isFolder) {
                for (var j = 0; j < item.children.length; j++) {
                    var subItem = item.children[j];
                    if (subItem.key === key) {
                        item.children.splice(j, 1);
                        return subItem;
                    }
                }
            } else {
                if (item.key === key) {
                    data.splice(i, 1);
                    return item;
                }
            }
        }
    }

    /**
     * 重置状态
     * @param data
     * @param key
     */
    const resetHoverStatus = (data: any, key: any) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].key === key) {
                data[i].isHover = true;
            } else {
                data[i].isHover = false;
            }
            if (data[i].children) {
                resetHoverStatus(data[i].children!, key);
            }
        }
    }

    //添加子画布
    const onAddItem = async (destNode:any = null) => {
        //保存下当前画布的...
        await props.onSaveNotes();
        if (!hasLicense() && !hasDesktopBaseLicense()) {
            let nCount: any = await getBoardCount();
            if (nCount >= 5) {
                window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToMoreBoard"), t("Cancel"), t("Learn more"), null, () => {
                    if (isZh()) {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    } else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                return;
            }
        }
        mIsAddFolder = false;
        let nCount = 0;//getPagesCount()
        let szKey = treeSelectedKeys[0];
        if (destNode && destNode.isFolder){
            nCount = destNode.children.filter(p=>!p.isFolder).length;
        }else{
            loop(menuData,szKey,(node, i, data, parent)=>{
                if (parent){
                    nCount = parent.children.filter(p=>!p.isFolder).length;
                }else{
                    nCount = menuData.filter(p=>!p.isFolder).length;
                }
            })
        }

        onAddNewCanvas(t("Board") + " " + (nCount + 1),true,destNode);
    }

    //添加文件夹画布
    const onAddFolder = (destNode:any = null) => {
        //保存一下。。。--在画布上有可能刚加的元素还没有保存，比如新插入的图片...
        props.onSaveNotes().then(res=>{
            mIsAddFolder = true;
            let nFolderCount = 0;//getFolderCount(menuData);
            //用当前选中的这个画板的
            let szKey = treeSelectedKeys[0];
            if (destNode && destNode.isFolder){
                nFolderCount = destNode.children.filter(p=>p.isFolder).length;
            }else{
                loop(menuData,szKey,(node, i, data, parent)=>{
                    if (parent){
                        nFolderCount = parent.children.filter(p=>p.isFolder).length;
                    }else{
                        nFolderCount = menuData.filter(p=>p.isFolder).length;
                    }
                })
            }
            onAddNewCanvas(t("Folder") + " " + (nFolderCount + 1),true,destNode);
        });
    }

    //添加画布--借用全局的
    window.onAddNewCanvas = (destNode:any = null) => {
        mIsAddFolder = false;
        const nCount = getPagesCount()
        return onAddNewCanvas(t("Board") + " " + (nCount + 1), false,destNode);
    };

    //添加画布
    const onAddNewCanvas = (szInputTitle: string, hasAutoSelectedNew: boolean = true,destNode:any) => {
        let itemNew: any = null;
        if (mIsAddFolder) {
            //文件夹...
            let menuDataNew: any = [];
            itemNew = {
                title: szInputTitle,
                editValue: szInputTitle,
                key: generateRandomPageKey(),
                icon: <IconTreeFolderCollapse/>,
                isFolder: mIsAddFolder,
                isEditable: hasAutoSelectedNew,
                children: []
            }
            if (mSelectNode.current == undefined) {
                mSelectNode.current = menuData[0];
            }
            if (mSelectNode.current != null || destNode) {
                // 判断当前选中的级数
                // const nLevel = findNodeLevel(menuData,destNode?.key || treeSelectedKeys[0]);
                // if (nLevel > 1 || (destNode?.key && nLevel >= 1)){
                //     message.error(t("MaximumFolder"))
                //     return;
                // }

                menuDataNew.push(...menuData)
                //不能无限嵌套---->插入到当前选中的后面一个位置...
                if (destNode){
                    //直接插入到这个节点的最下面。。--只有文件夹才有这个操作
                    destNode.children.push(itemNew);
                }else{
                    loop(menuDataNew, treeSelectedKeys[0], (_, index, arr, parent) => {
                        if (parent != undefined && parent.isFolder) {
                            parent.children.splice(index + 1, 0, itemNew);
                        } else {
                            menuDataNew.splice(index + 1, 0, itemNew);
                        }
                    });
                }

            } else {
                menuDataNew.push(...menuData)
                if (menuDataNew.length == 0) {
                    menuDataNew.push(itemNew);
                } else {
                    //插入到当前选中的后面一个位置...
                    loop(menuDataNew, treeSelectedKeys[0], (_, index, arr, parent) => {
                        if (parent != undefined && parent.isFolder) {
                            // parent.children.splice(index+1,0,itemNew);
                            //不能无限嵌套--插入到最后
                            menuDataNew.push(itemNew);
                        } else {
                            menuDataNew.splice(index + 1, 0, itemNew);
                        }
                    });
                }
            }

            setMenuData(menuDataNew);

            //展开这个...
            const expandKeysNew = [...expandKeys];
            const parents = findNodeWithParents(menuDataNew,itemNew.key);
            if (parents?.parents){
                for (let i=0;i<parents.parents.length;i++){
                    const pp = parents.parents[i];
                    pp.icon = <IconTreeFolderExpand/>
                    if (!expandKeysNew.includes(pp.key)){
                        expandKeysNew.push(pp.key);
                    }
                }
            }
            setExpandKeys(expandKeysNew);

            canvaItemSelect(menuDataNew);
        } else {
            //添加到子画布
            let menuDataNew: any = [];
            let expandKeysNew: any = [...expandKeys];
            itemNew = {
                title: szInputTitle,
                editValue: szInputTitle,
                key: generateRandomPageKey(),
                icon: <IconBoard/>,
                isFolder: mIsAddFolder,
                isEditable: hasAutoSelectedNew,
                drawJson: []
            };
            if (!hasAutoSelectedNew) {
                itemNew.drawJson = {
                    appState: {
                        scrollX: 0,
                        scrollY: 0,
                        viewBackgroundColor: isDarkMode() ? DEFAULT_CANVAS_BACKGROUND_DARK : DEFAULT_CANVAS_BACKGROUND,
                        zoom: {value: 1}
                    },
                    elements: [],
                    files: [],
                    type: 'excalidraw',
                    version: 2,
                }
            }
            if (mSelectNode.current != null || destNode) {
                // mSelectNode.children.push(itemNew);
                // menuDataNew.push(...menuData);
                // expandKeysNew.push(mSelectNode.key);
                //添加到最后---NEW
                menuDataNew.push(...menuData);

                if (destNode){
                    destNode.children.push(itemNew);
                }else{
                    //插入到当前选中的后面一个位置...
                    loop(menuDataNew, treeSelectedKeys[0], (_, index, arr, parent) => {
                        if (parent != undefined && parent.isFolder) {
                            parent.children.splice(index + 1, 0, itemNew);
                        } else {
                            menuDataNew.splice(index + 1, 0, itemNew);
                        }
                    });
                }
            } else {
                menuDataNew.push(...menuData);

                // if (menuDataNew.length == 0 || !hasAutoSelectedNew) {//插入到最后一条.
                //     menuDataNew.push(itemNew);
                // } else {
                //     //插入到当前选中的后面一个位置...
                //     loop(menuDataNew, treeSelectedKeys[0], (_, index, arr, parent) => {
                //         if (parent != undefined && parent.isFolder) {
                //             parent.children.splice(index + 1, 0, itemNew);
                //         } else {
                //             menuDataNew.splice(index + 1, 0, itemNew);
                //         }
                //     });
                // }
                menuDataNew.push(itemNew);
            }
            //增加一个排序...
            for (let i = 0; i < menuDataNew.length; i++) {
                menuDataNew[i].sort = i;
            }
            setMenuData(menuDataNew);

            //展开这个...
            const parents = findNodeWithParents(menuDataNew,itemNew.key);
            if (parents?.parents){
                for (let i=0;i<parents.parents.length;i++){
                    const pp = parents.parents[i];
                    pp.icon = <IconTreeFolderExpand/>
                    if (!expandKeysNew.includes(pp.key)){
                        expandKeysNew.push(pp.key);
                    }
                }
            }
            setExpandKeys(expandKeysNew);

            if (hasAutoSelectedNew) {
                //选中新建
                selectNewItemAndNav(itemNew, menuDataNew);
                //新建canvas
                props.onNewCanvasClick();
            }

            setHasFrameElement(false);

            if (!isCollapsePage){
                message.info(t('Subboard created'))
            }else{
                window.showMessageTip(t('SubboardCreatedOpenSidebar'),t('View'),null,()=>{
                    onCollapsePages();
                })
            }

        }
        if (hasAutoSelectedNew){
            setTreeDraggable(false);
        }else{
            setTreeDraggable(true);
        }


        setTimeout(()=>{
            window.onUpdateNoteFilter();
            //及时保存一下
            props.onSaveNotes();
        },300)
        return itemNew;
    }

    //选中并转到新建的.
    const selectNewItemAndNav = (itemNew: any, arrayNewMenu: any) => {
        mSelectNode.current = itemNew;
        setTreeSelectedKeys([itemNew.key])
        canvaItemSelect(arrayNewMenu);
    }

    const onClick: MenuProps['onClick'] = (e) => {
        console.log('click', e);
        setIsTreeItemHoverPopupVisible(false);
        mszMessageBoxAction = e.key;
        if ("copy" == e.key) {

        } else if ("rename" == e.key) {
            const data = [...menuData];
            loop(data, e.key, (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);
        } else if ("delete" == e.key) {
            setIsMessageBoxShow(true);
        }
    };

    /**
     * page的数量
     */
    const pagesCount = (arrayMenuDatas) => {
        let nPage = 0;
        for (let i = 0; i < arrayMenuDatas.length; i++) {
            let item = arrayMenuDatas[i];
            if (item.isFolder) {
                nPage += item.children.length;
            } else {
                nPage++;
            }
        }
        return nPage;
    }

    const onMenuItemContextMenu = (szAction: any,nodeData:any = null) => {
        mszMessageBoxAction = szAction;
        const data = [...menuData];
        const szRightDataId:string = mRightData.current?.node.key;
        // global.g_currentBoardId
        if ("copy" == szAction) {
            loop(data, szRightDataId, (item, index, type, parent) => {
                var newItem = Object.assign({}, item);
                newItem.title = newItem.editValue = newItem.title + "(" + t("Copy") + ")"
                newItem.key = nanoid();
                if (szRightDataId == treeSelectedKeys[0]){
                    newItem.drawJson = props.getCurrentDrawJson();
                }else{
                    newItem.drawJson = item.drawJson;
                }

                if (parent != undefined) {
                    parent.children.splice(index + 1, 0, newItem);
                } else {
                    data.splice(index + 1, 0, newItem);
                }
                setMenuData(data);
                selectNewItemAndNav(newItem, data);
            });
        } else if ("rename" == szAction) {
            //treeSelectedKeys[0] 为什么右键取出来的总是另一个？？？？ 总是不同步。。。设置了也没用。。。为什么？？？？
            loop(data, szRightDataId, (item) => {
                item.isEditable = true;
                item.editValue = item.title;
            });
            setMenuData(data)
            setTreeDraggable(false);

            if (nodeData){
                setTimeout(()=>{
                    const txt = document.getElementById('txt-directory-item-'+nodeData.key);
                    if (txt){
                        txt.focus();
                    }
                },100)
            }

        } else if ("delete" == szAction) {
            // let currentMenu;
            // loop(data, szRightDataId, (item, num, node, parent) => {
            //     currentMenu = item;
            // })
            // //是否有页面
            // if (pagesCount(menuData) <= 1 && !currentMenu?.isFolder) {
            //     Modal.error({
            //         content: t("Can not delete page")
            //     })
            //     return;
            // }
            //
            // if (menuData.length == 1) {
            //     let msg = t("Can not delete page");
            //     if (menuData[0].isFolder && menuData[0].key == treeSelectedKeys[0]) {
            //         msg = t("Can not delete folder");
            //     }
            //     loop(data, treeSelectedKeys[0], (item, num, node, parent) => {
            //         if (parent != undefined) {
            //             msg = '';
            //         }
            //     });
            //
            //     if (!isStringNullOrEmpty(msg)) {
            //         Modal.error({
            //             content: msg
            //         })
            //         return;
            //     }
            // }
            if (!canBeDelete(szRightDataId))return;

            {
                let msg = t("Delete canvas not restore");
                loop(data, szRightDataId, (item, num, node, parent) => {
                    if (item.isFolder) {
                        msg = t("DeleteTheFolder")
                    }
                });
                dialogMessageBoxRef?.current.onShowDialog(t("Tips"), msg, t("Delete"), () => {
                    onMessageBoxOk();
                })
            }
        } else if ("moveTo" == szAction) {
            loop(data, szRightDataId, (item, index, type, parent) => {
                var newItem = Object.assign({}, item);
                newItem.key = nanoid();
                if (szRightDataId == treeSelectedKeys[0]){
                    newItem.drawJson = props.getCurrentDrawJson();
                }else{
                    newItem.drawJson = item.drawJson;
                }
                newItem.icon = '';
                props.onAction('moveTo', newItem,{oldKey:item.key})
            });
        } else if ('favor' == szAction) {
            loop(data, szRightDataId, (item, index, type, parent) => {
                getBoardById(treeSelectedKeys[0]).then(res => {
                    let board: any = {};
                    if (res) {
                        board = {...res};
                    } else {
                        board = {
                            id: szRightDataId,
                            projectId: PROJECT_ID,
                        }
                    }
                    if (board.isFavirated == 1) {
                        board.isFavirated = 0;
                    } else {
                        board.isFavirated = 1;
                    }
                    board.favirateTime = Date.now();
                    board.type = 'board';
                    board.sort = 0;
                    board.name = item.title

                    updateBoard(board).then(r => {
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    })
                })
            })
        }
    }

    /**
     * 这个是否能被删除
     * @param szKey
     */
    const canBeDelete = (szKey)=>{
        let isOnlyBoard = false;
        let nBoardCount = 0;
        let selectNode000 = null;
        loopAllNode(menuData,item=>{
            if (item.drawJson?.elements && !item.isFolder){
                nBoardCount ++;
            }
            if (szKey == item.key){
                selectNode000 = item;
            }
        })
        if (nBoardCount == 1){
            if (selectNode000.isFolder){
                //这个文件夹下是否有画布..
                let nChildBoardCount = 0;
                loopAllNode(selectNode000.children,(iiiiitttt)=>{
                    if (!iiiiitttt.isFolder && iiiiitttt.drawJson?.elements){
                        nChildBoardCount ++;
                    }
                })
                if (nChildBoardCount == 1){
                    message.error(t('CantDeleteAll'));
                    return false;
                }
            }else{
                message.error(t("Can not delete page"));
                return false;
            }
        }
        let parentNode = null;
        loop(menuData,szKey,(node, i, data, parent)=>{
            parentNode = parent;
        })

        if (menuData.length == 1 && !parentNode) {
            message.error(t('CantDeleteAll'));
            return false;
        };//只有一个不能删除...
        return true;
    }

    //弹出确认框
    const onMessageBoxOk = () => {
        setIsMessageBoxShow(false);

        if ("delete" == mszMessageBoxAction) {
            //删除
            onRemoveSelectedItem(mRightData.current?.node?.key);
        }
    }

    /**
     * 删除
     */
    const onRemoveSelectedItem = (szKey:any,szMovedProjectId,szNewBoardId) => {
        if (!canBeDelete(szKey))return;

        //会自动跳转到同一个层级的上一个画布
        //如果删除的是文件夹里的第一个画布（或者唯一的子画布），就自动跳转到项目的第一个画布
        var newData = [...menuData];
        var selectPreNode = null;
        const szSelectBoardId = szKey || treeSelectedKeys[0];
        let selectNode = null;
        loop(newData, szSelectBoardId, ((node, i, data, parent) => {
            selectNode = node;

            if (parent != null) {
                parent.children.splice(i, 1);
                if (i < parent.children.length) {
                    selectPreNode = parent.children[i];
                }
            } else {
                newData.splice(i, 1);
                if (i < newData.length) {
                    selectPreNode = newData[i];
                }
            }
        }))

        //将当前项目包含projectLink的更新....移动那里更新没用，因为这里会重新保存，所以要更新这里.
        loopAllNode(newData,(canvas)=>{
            if (canvas.drawJson?.elements){
                for (let ii=0;ii<canvas.drawJson.elements.length;ii++){
                    const el = canvas.drawJson.elements[ii];
                    if (isProjectLinkElement(el)){
                        if (el.customData.projectId == PROJECT_ID && el.customData?.boardId == szKey){
                            el.customData.projectId = szMovedProjectId;
                            el.customData.boardId = szNewBoardId;
                            const customData = {...el.customData};
                            if (window.updateElement){
                                window.updateElement(el, {customData:customData});
                            }
                        }
                    }
                }
            }
        })

        setMenuData(newData);
        //是当前选中的....
        let isInTree = false;
        if (selectNode?.isFolder){
            isInTree = isKeyInTree(selectNode.children,treeSelectedKeys[0]);
        }
        if (isInTree || szKey == treeSelectedKeys[0]){
            if (selectPreNode == null) {
                selectPreNode = getFirstCanvasNode(newData);
            }
            if (selectPreNode != null) {
                mSelectNode.current = selectPreNode;
            }
            setTreeSelectedKeys([mSelectNode.current.key]);
            canvaItemSelect(newData);
        }

        //如果有收藏的话，移除收藏并刷新--各种不能正确同步---
        deleteBoardById(szSelectBoardId).then(async(res) => {
            postMessage(EVENT_FAVIRIATE_CHANGE);
            //保存
            setTimeout(()=>{
                props.onSaveNotes();
            },100)
        })
    }

    /**
     * 更新一个board
     * @param newBoard
     */
    const onUpdateBoard = (newBoard: any) => {
        const newMenuData = [...menuData];
        for (let i = 0; i < newMenuData.length; i++) {
            if (newMenuData[i].key == newBoard.key) {
                newMenuData[i] = newBoard;
                break;
            }
        }
        setMenuData(newMenuData);
    }

    /**
     * 笔记列表选中
     * @param treeNoteItem
     */
    const noteLeftMenuItemClicked = (treeNoteItem) => {
        props.onSubNoteClick(treeNoteItem);
    }
    //插入笔记内容到画布
    const onInsertNoteData = (noteData, isAutoInsert) => {
        //这里先更新所有画布--然后更改这个笔记关联的所有element...
        var arrayNewMenu = [...menuData];
        recursionAllElement(arrayNewMenu, noteData);
        setMenuData(arrayNewMenu);

        props.onInsertNoteData(noteData, isAutoInsert);
    }

    /**
     * 递归所有画布，找到当前这个笔记的元素，然后更新
     * @param arrayMenus
     */
    function recursionAllElement(arrayMenus, noteData) {
        for (var i = 0; i < arrayMenus.length; i++) {
            var item = arrayMenus[i];
            if (item.isFolder) {
                recursionAllElement(item.children, noteData);
            } else {
                var arrayEles = item.drawJson.elements;
                if (arrayEles != undefined) {
                    for (var j = 0; j < arrayEles.length; j++) {
                        var ele = arrayEles[j];
                        if (ele.type == 'iframe' && ele.id == noteData.id) {
                            if (ele.customData != undefined && ele.customData.generationData != undefined) {
                                ele.customData.generationData.html = createElementNameByNote(noteData.name) + noteData.doc;
                            }
                        }
                    }
                }
            }
        }
    }

    /**
     * 笔记删除的时候---删除所有笔记的引用....
     * @param szKey
     */
    const onNoteDataDelete = (szKey: string) => {
        var arrayNewMenu = [...menuData];
        recursionAllElementForDelete(arrayNewMenu, szKey);
        setMenuData(arrayNewMenu);
    }

    /**
     * 递归所有画布，找到当前这个笔记的元素，然后删除
     * @param arrayMenus
     */
    function recursionAllElementForDelete(arrayMenus, szKey) {
        for (var i = 0; i < arrayMenus.length; i++) {
            var item = arrayMenus[i];
            if (item.isFolder) {
                recursionAllElement(item.children, noteData);
            } else {
                var arrayEles = item.drawJson.elements;
                if (arrayEles != undefined) {
                    for (var j = 0; j < arrayEles.length; j++) {
                        var ele = arrayEles[j];
                        if (ele.type == 'iframe' && ele.id == szKey) {
                            var arrayNew = arrayEles.splice(j, 1);
                            item.drawJson.elements = arrayEles;
                            break;
                        }
                    }
                }
            }
        }
    }

    const noteGetCurrentDrawJson = () => {
        return props.getCurrentDrawJson();
    }

    /**
     * 获取所有页
     */
    const getAllPages = () => {
        let arrayAllPages = [];
        let nCurIndex = 0;
        for (let i = 0; i < menuData.length; i++) {
            var item = menuData[i];
            if (item.isFolder) {
                arrayAllPages.push(...item.children);
            } else {
                arrayAllPages.push(item);
            }
        }
        return arrayAllPages;
    }

    /**
     * 折叠或展开
     */
    const onCollapsePages = () => {
        var isCollapse = !isCollapsePage;
        localStorage.setItem(KEY_DRAW_LEFT_COLLAPSE, isCollapse + '');
        setIsCollapsePage(isCollapse);
        props.onCollapseClick(isCollapse);
    }

    const onUpdateSort = (arrayTreeFrameList) => {
        //更新界面上的元素.....
        postMessage(EVENT_UPDATE_FRAME_SORT, {arrayTreeFrameList});
        /*
        var arrayNew = [...menuData];
        // //当前page
        for (let k=0;k<arrayNew.length;k++) {
            let note = arrayNew[k];
            if (note.isFolder) {
                for (let n = 0;n<note.children.length;n++) {

                }
            }else {
                if(note.key == treeSelectedKeys[0]) {
                    var arrayElements = [];
                    for (let i=0;i<note.drawJson.elements.length;i++){
                        const item = note.drawJson.elements[i];
                        if (item.type != 'frame'){
                            arrayElements.push(item);
                        }
                    }
                    for (let i=0;i<arrayTreeFrameList.length;i++){
                        arrayElements.push({
                            ...arrayTreeFrameList[i].element,
                            sort:i
                        });
                    }

                    var newNote = {
                        ...note,
                    };
                    newNote.drawJson.elements = arrayElements;
                    arrayNew.splice(k,1);
                    arrayNew.push(newNote);

                    break;
                }
            }
        }

        mTest = arrayNew;
        setMenuData(arrayNew);*/
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: APP_WEB ? 'calc(100vh - 40px)' : `calc(100vh - ${isPresentMode ? (HEADER_TOP() - TITLE_BAR_HEIGHT) : HEADER_TOP()}px)`,
            overflow: 'visible',
            backgroundColor: 'transparent',
            boxShadow: (isCollapsePage || isPresentMode) ? '0px 2px 6px 0px rgba(157,158,177,0)' : '0px 2px 6px 0px rgba(157,158,177,0)',
        }}>
            {/*backgroundImage:'url('+imgPathPerfix()+"expand_or_background.png)"*/}
            {
                // isShowPageTree &&
                // <div className='left-menu-clopse' onClick={onCollapsePages} style={{
                //     visibility: isPresentMode ? 'visible' : 'visible', pointerEvents: 'auto',
                //     right: isCollapsePage ? '166px' : '-19px',
                //     display: 'flex', alignItems: 'center', justifyContent: 'center',
                // }}>
                //     <div style={{position: 'relative'}} className='cursor-pointer'>
                //         <img style={{height: '107px'}} src={imgPathPerfix() + "expand_or_background.png"}/>
                //         <img src={imgPathPerfix() + (isCollapsePage ? 'to_expand.png' : 'to_collapse.png')}
                //              style={{
                //                  width: '16px',
                //                  height: '20px',
                //                  position: 'absolute',
                //                  left: isCollapsePage ? '0' : '-2px',
                //                  top: 'calc(50% - 10px)'
                //              }}/>
                //     </div>
                // </div>
            }

            <Flex gap={"middle"} style={{
                width: '100%',
                height: isPresentMode ? '100%' : boardHeight + 'px',
                border: isPresentMode ? '0' : '0px',
                borderRadius: isPresentMode ? '0px' : '0px',
                marginLeft: isPresentMode ? '0px' : '0px',
                backgroundColor: isPresentMode ? (isPresentMode ? "#2C2C2C" : 'white') : 'transparent',
                boxShadow: isPresentMode ? '0px 2px 6px 0px rgba(157,158,177,0)' : '0px 2px 6px 0px rgba(157,158,177,0)',
                display: (isCollapsePage) ? 'none' : 'inherit',
                visibility: (isShowOverlay || !isPresentMode) ? 'visible' : 'collapse',
                opacity: (isShowOverlay || !isPresentMode) ? 1 : 0,
                position: 'relative',
                marginTop: '2px',
                pointerEvents: pointerEvent
            }} vertical>
                {
                    <div className="left-menu-title" style={{
                        visibility: isPresentMode ? 'hidden' : 'visible',
                        display: 'flex',
                        alignItems: 'center',
                        height: '36px',
                        minHeight: '36px'
                    }}>
                        <span className='ml-4 font-family-medium font-size-12'
                              style={{color: isFramePresent ? "white" : "var(--text-color)"}}>{t("Boards")}</span>
                        <span style={{flexGrow: 1}}></span>
                        {/*<Button style={{visibility: isPresentMode ? 'hidden' : 'visible'}} type="text" shape="circle"*/}
                        {/*        icon={<FolderOutlined rev={undefined}/>} onClick={onAddFolder}/>*/}

                        <Tooltip title={t('New board')} arrow={false}>
                            <img style={{visibility: isPresentMode ? 'hidden' : 'visible', marginRight: '12px'}}
                                 className='img-14 cursor-pointer' src={getImagePathWithTheme('icon_add_light.svg')}
                                 onClick={() => {
                                     onAddItem();
                                 }}/>
                        </Tooltip>

                        <Tooltip title={t('New folder')} arrow={false}>
                        <img className={'img-14 mr-10 cursor-pointer mt-1'}
                             src={getImagePathWithThemeSvg('icon_floder_light')} onClick={() => {
                            onAddFolder();
                        }}/>
                        </Tooltip>
                    </div>
                }

                <div ref={mDivLeftMenuContainer} id={'div-tree-left-menu'} className='hovered-overflow-y-auto'
                     style={{marginTop: isPresentMode ? '-36px' : '-12px',height:'100%'}}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Tree: {
                                    // colorPrimary: isPresentMode ? "#212121" : (isPresentMode ? '#DCEDFF' : '#DCEDFF00'),
                                    colorPrimary: 'var(--primary-color)',
                                    directoryNodeSelectedBg:isPresentMode?'#444444':'var(--select-background-color)',
                                    indentSize:0,
                                    borderRadius:0,
                                    titleHeight:32,
                                    // 拖拽相关颜色---下面几个配置是一点用都没有。。。。
                                    // dragOverBg: '#e6fffb',           // 拖拽经过可放置区域的背景色
                                    // dragOverGapBg: '#f6ffed',        // 拖拽到间隙时的背景色
                                    // dropIndicatorBg: '#1890ff',      // 拖拽指示线颜色
                                }
                            }
                        }}
                    >
                        <DirectoryTree
                            className={`tree-board-fuck-css-left-align ${isPresentMode?'tree-garbage-stuff-force-dark':''}`}
                            // className={'favor-tree-class'}
                            // switcherIcon={<CaretDownOutlined style={{color: 'black'}} rev={undefined}/>}
                            switcherIcon={null}
                            expandedKeys={expandKeys}
                            onExpand={onExpand}
                            // autoExpandParent={true}
                            onSelect={onSelect}
                            treeData={menuData}
                            selectedKeys={treeSelectedKeys}
                            showIcon={!isPresentMode}
                            blockNode={true}
                            onRightClick={(info, node) => {
                                mRightData.current = info;
                            }}
                            onMouseEnter={onTreeMouseEnter}
                            onMouseLeave={onTreeMouseLeave}
                            draggable={treeDraggable}
                            onDragOver={onDragOver}
                            onDragStart={onDragStart}
                            onDragEnd={onDragEnd}
                            onDrop={onDrop}
                            titleRender={(nodeData: DataNode) => {
                                if (nodeData.isEditable) {
                                    return (
                                        <Dropdown overlayClassName='default-dropdown-style'
                                                  menu={{items: arrayBoardMenus}}
                                                  trigger={['contextMenu']} overlayStyle={{width: 'auto'}}
                                                  onOpenChange={async (e, info) => {
                                                      getBoardById(treeSelectedKeys[0]).then((res: any) => {
                                                          setArrayBoardMenus(getMenus(res,nodeData))
                                                      });
                                                  }}>
                                        <div style={{display: "flex", width: "auto", alignItems: "center"}}>
                                            {/*<img className='img-14'*/}
                                            {/*     src={(nodeData.isFolder && expandKeys.some(p => p.includes(nodeData.key))) ? getImagePathWithTheme('favor_folder_expand.svg') : getImagePathWithTheme('favor_folder.svg')}/>*/}
                                            <Input id={'txt-directory-item-'+nodeData.key} value={nodeData.editValue || ''}
                                                   className='default-font-size font-family-regular'
                                                   style={{
                                                       color: "var(--text-color-dark-color)",
                                                       marginLeft: '0px',
                                                       paddingLeft: '0px',
                                                       marginBottom: '0px',
                                                       flexGrow: 1,
                                                       paddingTop: '6px',
                                                   }}
                                                   variant={"borderless"}
                                                   autoFocus={true}
                                                   onKeyPress={(e) => onCanvasKeyPress(e, nodeData.key)}
                                                   onChange={(e) => onChange(e, nodeData.key)}
                                                   onBlur={(e) => onBlur(e, nodeData.key)}
                                            />
                                            {/*<div style={{width: '16px', height: '16px', marginLeft: '2px'}}></div>*/}
                                        </div>
                                        </Dropdown>
                                    )
                                } else {
                                    return (
                                        <Dropdown overlayClassName='default-dropdown-style'
                                                  menu={{items: arrayBoardMenus}}
                                                  trigger={['contextMenu']} overlayStyle={{width: 'auto'}}
                                                  onOpenChange={async (e, info) => {
                                                      getBoardById(treeSelectedKeys[0]).then((res: any) => {
                                                          setArrayBoardMenus(getMenus(res,nodeData))
                                                      });
                                                  }}>
                                            <div className='custom-element' id={nodeData.key}
                                                 style={{display: "flex", width: 'auto', alignItems: "center"}}>
                                                {/*<img className='img-14'*/}
                                                {/*     src={getImagePathWithTheme('board.svg')}/>*/}
                                                <Input className='default-font-size font-family-regular no-select-force span-single-line'
                                                       readOnly={true}
                                                       bordered={false}
                                                       style={{
                                                           color: isPresentMode ? "white" : ((treeSelectedKeys[0] == nodeData.key) ? "var(--text-color-dark-color)" : "var(--text-color-dark-color)"),
                                                           marginLeft: '0px',
                                                           paddingLeft: '0px',
                                                           cursor: "pointer",
                                                           flexGrow: '1',
                                                           paddingTop: '6px',
                                                           marginBottom: '0px',
                                                           paddingRight: '8px',
                                                       }}
                                                       value={nodeData.title}/>

                                                {/*<Dropdown menu={{items}} trigger={['click']}>*/}
                                                {/*    <img className='img-mini-small-12 hovered' src={imgPathPerfix()+"vertical_more.png"} style={{*/}
                                                {/*        visibility: nodeData.isHover ? "visible" : "hidden",*/}
                                                {/*        width: '18px',*/}
                                                {/*        height: '18px',*/}
                                                {/*        padding:'4px',*/}
                                                {/*        flexShrink:'0',*/}
                                                {/*        marginLeft: '2px',*/}
                                                {/*        marginRight:'8px',*/}
                                                {/*        color:'#333333'*/}
                                                {/*    }}/>*/}
                                                {/*</Dropdown>*/}
                                                <Dropdown menu={{
                                                    items: getMenus(null,nodeData),
                                                    // onClick: handleMenuClick
                                                }} trigger={['click']} align={{offset: [26, -26]}} onOpenChange={(e)=>{
                                                    if (e) {
                                                        mRightData.current = {node:nodeData};
                                                    }
                                                }}>
                                                    <div className={'flex-center'} style={{
                                                        height: '100%',
                                                        width: '26px',
                                                        flexShrink: '0',
                                                        marginRight: '0px',
                                                        display:(hoveredKey == nodeData.key)?'':'none'
                                                    }} onClick={(event)=>{
                                                        event.stopPropagation();
                                                    }}>
                                                        <img className='img-medium-small'
                                                             style={{flexShrink: '0',opacity:(hoveredKey == nodeData.key)?'1':'0'}}
                                                             src={getImagePathWithTheme("horizontal_more")} />
                                                    </div>
                                                </Dropdown>
                                            </div>
                                        </Dropdown>
                                    )
                                }
                            }}
                        />
                    </ConfigProvider>
                </div>

            </Flex>

            {
                hasFrameElement && false &&
                <div id={'div-leftmenu-frame-drag-line'}
                     style={{display: (isCollapsePage) ? 'none' : 'inherit'}}
                     className={'drag-line-v'} onMouseDown={(event) => {
                    mIsFrameLineDrag = true;
                    mPressedY = event.clientY;
                }}></div>
            }


            {/*frame列表-------------------不显示了。使用content*/}
            {
                false &&
                <div style={{
                    backgroundColor: isPresentMode ? (isPresentMode ? "#2C2C2C" : 'white') : 'transparent',
                    // borderTop: !isPresentMode ? '1px solid var(--draw-border-top-color)' : '1px solid #212121',
                    height: isPresentMode ? document.body.clientHeight * 0.4 + 'px' : frameHeight + 'px',
                    width: '100%',
                    paddingTop: '4px',
                    display: ((isCollapsePage) || !hasFrameElement) ? 'none' : 'inherit',
                    visibility: (isShowOverlay || !isPresentMode) ? 'visible' : 'collapse',
                    opacity: (isShowOverlay || !isPresentMode) ? 1 : 0,
                    pointerEvents: pointerEvent
                }}>
                    <TreeListFrame ref={treeListFrameRef} onItemClicked={(element) => {
                        props.onSelectedElement(element);
                    }} onUpdateSort={(arrayTreeFrameList: any) => {
                        //what ????/ 不能更新？？？？？？？？
                        onUpdateSort(arrayTreeFrameList)
                    }}/>
                </div>
            }


            {/*拖动线条*/}
            <div id={'div-leftmenu-card-drag-line'} className={'drag-line-v'}
                 style={{
                     display: (isCollapsePage || isPresentMode) ? 'none' : 'inherit',
                     background:isPresentMode?'#444444':'var(--drag-line-color)',
                     visibility: (isShowOverlay || !isPresentMode) ? 'visible' : 'collapse',
                     opacity: (isShowOverlay || !isPresentMode) ? 1 : 0,
            }}
                 onMouseDown={(event) => {
                     mIsCardLineDrag = true;
                     mPressedY = event.clientY;
                 }}></div>

            {/*笔记列表*/}
            <div id={'div-leftmenu-card-container'} style={{
                borderTop: '0px solid var(--draw-border-top-color)',
                height: cardHeight + 'px',
                width: '100%',
                paddingTop: '4px',
                paddingBottom: '10px',
                flexShrink:'0',
                display: (isCollapsePage || isPresentMode) ? 'none' : 'inherit',
                backgroundColor: isPresentMode ? (isPresentMode ? "#2C2C2C" : 'white') : 'transparent',
                visibility: (isShowOverlay || !isPresentMode) ? 'visible' : 'collapse',
                opacity: (isShowOverlay || !isPresentMode) ? 1 : 0,
                pointerEvents: pointerEvent
            }}>
                {
                    <TreeListNode ref={treeNodeNoteRef} title={t('Cards')}
                                  treeNodeType={TREENODETYPE.TREE_NODE_TYPE_NOTES}
                                  leftMenuItemClicked={noteLeftMenuItemClicked}
                                  onInsertNoteData={onInsertNoteData}
                                  leftMenuDeleteNotes={onNoteDataDelete}
                                  onGetBroadData={() => {
                                      var arrayNew: any = [...menuData];
                                      for (let i = 0; i < arrayNew.length; i++) {
                                          if (arrayNew[i].key == mTreeSelectedKey.current) {//treeSelectedKeys[0]不能用这个,如果刚好赶巧了，删了card后，立即切换board，这个时候treeSelectedKey还没有更新，然后取到的drawjson就是新切换到的这个，然后设置了错误的东西。。。。。。。。。。
                                              arrayNew[i].drawJson = props.getCurrentDrawJson()
                                          }
                                      }
                                      return arrayNew;
                                  }}
                                  getCurrentDrawJson={noteGetCurrentDrawJson}/>
                }

                {
                    <TreeListContent ref={treeListContentRef} height={cardHeight} onAction={(szAction,extra)=>{
                        if (szAction == 'zoomTo'){
                            props.onSelectedElement(extra?.element);
                        }else if (szAction == 'openElement'){
                            props.onAction('openElement',extra?.element);
                        }
                    }}/>
                }

            </div>


            <Modal title="提示" open={isMessageBoxShow} onOk={onMessageBoxOk}
                   onCancel={() => setIsMessageBoxShow(false)}>
                <p>{t("Delete canvas not restore")}</p>
            </Modal>

            <DialogMessageBox ref={dialogMessageBoxRef}/>
        </div>
    )
});
export default LeftMenu;























